export default __webpack_public_path__ + "static/media/whyIsStudyDone_sm_woman.68097d6c.png";